//MYSQL
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_CHECK, AUTH_CHECK_OK, AUTH_ORG_SUCCESS, AUTH_INTO_ORG, LOGOUT_ORG, LOGOUT_ORG_SUCCESS  } from '../actions/auth'
import Vue from 'vue'
import Cookies from 'js-cookie'
import axios from 'axios'
import router from '@/router'
import jwt_decode from "jwt-decode";

const state = { 
    token: Cookies.get('user-token') || '', 
    status: '', 
    error: "", 
    
    user: '', 
    userID: '', 
    username: '', 
    email: '', 
    loggedIn: false, 
    organizationID: '', 
    role: 'user', 
    isAdmin: false, 
    isSuperadmin: false, 
    //LoggedInOrganizationToken: Cookies.get('atlass_lio') || '', 
    //LoggedInOrganization: false,   
    
}

const getters = {
    getToken: state => state.token,
    getUserID: state => state.userID,
    getUser: state => state.user,
    getUsername: state => state.username,
    getRole: state => state.role,
    isAdmin: state => state.isAdmin,
    getUserEmail: state => state.email,
    getFirstname: state => state.firstname,
    getLastname: state => state.lastname,
    //getOnboarding: state => state.onboarding,
    //getPro: state => state.pro,
    getOrganizationID: state => state.organizationID,
    authStatus: state => state.status,
    geterror: state => state.error,
    isAuthenticated: state => !!state.token,
    
    LoggedInOrganization: state => state.LoggedInOrganization,
    getLoggedInOrganizationID: state => state.loggedInOrganizationID,
    getLoggedInOrganizationName: state => state.loggedInOrganizationName,
}

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, user) => {

        //console.log("[AUTH_REQUEST]")
        
        //console.log( user )
        
        let params = JSON.stringify(
            {
                "username":  user.username,
                "password": user.password
            }
        )
        
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST)       
            
            params = encodeURIComponent(window.btoa(params))
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/auth/login.php', headers: { 'Content-Type': 'text/plain', }, data: params })
            .then(resp => {

                let r = resp.data;

                if( r.status == 200 ){

                    let userToken = r.data
                    //console.log( jwt_decode(userToken) )
                    //window.$cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user', userToken, null, null, null, false, true ) 

                    commit(AUTH_SUCCESS, jwt_decode(userToken) )
                    //dispatch(AUTH_CHECK);
                    resolve(r)
                    
                    router.push("/");
                    //window.location.reload()

                }else{
                    commit(AUTH_ERROR, r)
                    commit(AUTH_LOGOUT, 'error')
                    reject(r)
                }

            })
            
        }) //end new promise

    },
    [AUTH_INTO_ORG]: ({commit, dispatch}, orgID ) => {

        return new Promise((resolve, reject) => {
            //console.log(org)

            let headers = { 
                "X-Auth": Cookies.get('user-token')
            }

            let payloadData = { ID: orgID }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/sadmin/organizations/logIntoOrganization.php', headers: headers, data: payloadData })
            .then(resp => {

                let r = resp.data;

                if( r.status == 200 ){
                    
                    let userToken = r.data
                    console.log( jwt_decode(userToken) )
                    //window.$cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user', userToken, null, null, null, false, true ) 

                    commit(AUTH_SUCCESS, jwt_decode(userToken) )
                    //dispatch(AUTH_CHECK);
                    resolve(r)
                    
                    router.push("/");
                    
                    //window.location.reload()
                }
                
            }); //end axios
            
            //router.push({ path: '/' });
            //resolve()
            
        }) //end new promise

    },
    [LOGOUT_ORG]: ({commit, dispatch} ) => {

        return new Promise((resolve, reject) => {
            //console.log(org)

            let headers = { 
                "X-Auth": Cookies.get('user-token')
            }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/sadmin/organizations/logOutOfOrganization.php', headers: headers })
            .then(resp => {

                let r = resp.data;

                if( r.status == 200 ){
                    
                    let userToken = r.data
                    console.log( jwt_decode(userToken) )
                    //window.$cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user-token', userToken, null, null, null, false, true ) 
                    Cookies.set('user', userToken, null, null, null, false, true ) 

                    commit(AUTH_SUCCESS, jwt_decode(userToken) )
                    //dispatch(AUTH_CHECK);
                    resolve(r)
                    
                    router.push("/");
                    //window.location.reload()
                    
                }
                
            }); //end axios
            
            //router.push({ path: '/' });
            //resolve()
            
        }) //end new promise

    },
    [AUTH_LOGOUT]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            
            console.log( "AUTH_LOGOUT" )
            Cookies.remove('user-token' );
            commit(AUTH_LOGOUT, 'error' )
            
            router.push("/login");
            
        })
    },
    [AUTH_CHECK]: ({commit, dispatch}) => {
        //commit(AUTH_CHECK)
        let params = Cookies.get('user-token');
        let headers = { 
            'Content-Type': 'application/json;charset=utf-8', 
            'Access-Control-Allow-Headers': "*",  
            'Access-Control-Allow-Origin': "*",  
            'Access-Control-Allow-Credentials': "true",  
            "X-Auth": params 
        };

        //console.log("[AUTH_CHECK]")
        
        return new Promise((resolve, reject) => {

            axios({ method: 'POST', url: process.env.ROOT_API+'/api/auth/check.php', headers: headers })
            .then(resp => {
                //console.log(resp)
                let r = resp.data;
                
                if( resp.status != 200 || r.status != 200 ){

                    commit(AUTH_ERROR, r)
                    commit(AUTH_LOGOUT, 'error' )
                    Cookies.remove('user-token' );
                    reject(r)

                    router.push("/login");

                }else{
                    
                    //ALL GOOD
                    let userToken = jwt_decode(Cookies.get('user-token'))
                    //console.log( userToken )
                
                    commit(AUTH_SUCCESS, userToken)
                    resolve(r)
                    
                }

            })
            
        }) //end new promise
    
    },

}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, r) => {
    state.status = 'success'
    state.token = Cookies.get('user-token')
      
    //r -> jwt token; r.data -> user data stored in jwt token
    state.user = JSON.stringify(r.data)
    state.userID = r.data.userID
    state.email = r.data.email
    state.firstname = r.data.firstname
    state.lastname = r.data.lastname
    state.loggedIn = true
    state.role = r.data.role
    //state.isAdmin = r.data.isAdmin

    //organization
    state.OrganizationID = r.data.OrganizationID
    state.OrganizationName = r.data.OrganizationName
      
    if( r.data.OrganizationID != r.data.loggedInOrganizationID ){
       state.LoggedInOrganization = true
    }
    state.loggedInOrganizationID = r.data.loggedInOrganizationID
    state.loggedInOrganizationName = r.data.loggedInOrganizationName
      
    //console.log(r.data )
    state.isAdmin = false
    if( r.data.role <= 1 ){
       state.isAdmin = true
    }
      
    if( r.data.role == 0 ){
       state.isSuperadmin = true
    }
    //console.log(state)
    //state.organizationID = r.organizationID
  },
    
  [AUTH_ERROR]: (state, r) => {
    state.status = 'error'
    state.error = r.message
    state.hasLoadedOnce = false
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
    state.profile = {}
    state.token = ''
    state.user = ''
    state.userID = ''
    state.username = ''
    state.loggedIn = false
    state.hasLoadedOnce = false
  },
  [AUTH_CHECK]: (state) => {
    state.status = 'checking'
  },
  [AUTH_CHECK_OK]: (state) => {
    state.status = 'success'
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth_mysql.js